import type { User } from "@/features/auth/services/firebase";
import type { UserProfile } from "@/features/auth/contexts/auth/context";

interface OnboardingGuardParams {
  user: User | null;
  profile: UserProfile | null;
  accountDisabled: boolean;
  pathname: string;
}

export function useOnboardingGuard(params: OnboardingGuardParams) {
  const { user, profile, accountDisabled, pathname } = params;

  if (accountDisabled && user && pathname !== "/pending-approval") {
    return {
      redirectTo: "/pending-approval",
      showNav: false,
      profileUnavailable: false,
    };
  }

  // A signed-in user whose profile fetch failed (network error, non-2xx,
  // or thrown exception) gets its own explicit state rather than silently
  // falling through to the bare-div fallback below with no error UI.
  if (user && profile === null && !accountDisabled) {
    return {
      redirectTo: null,
      showNav: true,
      profileUnavailable: true,
    };
  }

  if (
    user &&
    profile &&
    profile.onboardingCompleted !== true &&
    pathname !== "/onboarding"
  ) {
    return {
      redirectTo: "/onboarding",
      showNav: false,
      profileUnavailable: false,
    };
  }

  return {
    redirectTo: null,
    showNav: !accountDisabled && (!user || profile?.onboardingCompleted === true),
    profileUnavailable: false,
  };
}
